import { FC } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const TermsOfUse: FC = () => {
  const { isAuthenticated, login } = useAuth();

  if (!isAuthenticated) {
    login();
  }

  return (
    <div className="terms">
      <h1>Terms of Use for CapIntel One-Time Secret Sharing Portal</h1>

      <h2>1. Purpose and Scope</h2>
      <p>This Portal is an internal, company-owned platform designed to facilitate secure, one-time sharing of sensitive information between employees. By using this Portal, you agree to the terms and conditions outlined below.</p>

      <h2>2. Authorized Users</h2>
      <p>This Portal is exclusively for use by authorized employees of CapIntel. Access to this Portal must not be shared externally or with unauthorized individuals. Violation of this restriction may result in disciplinary action and/or termination of access.</p>

      <h2>3. Usage Guidelines</h2>
      <ul>
          <li><strong>Permitted Use:</strong> This Portal is intended solely for the secure transmission of sensitive information within the company, such as credentials, access codes, and other confidential data that must be shared with authorized employees.</li>
          <li><strong>Prohibited Use:</strong> This Portal must not be used to share any information that violates company policies, such as personally identifiable information (PII) beyond the necessary scope, intellectual property, or data governed by regulatory constraints without explicit authorization.</li>
          <li><strong>Confidentiality and Security:</strong> Users are responsible for ensuring that they protect the link to the one-time secret from unauthorized access and only share it with colleagues who have a legitimate need to know.</li>
      </ul>

      <h2>4. Security and Expiry</h2>
      <ul>
          <li><strong>Encryption:</strong> All secrets shared through this Portal are encrypted using industry-standard methods to ensure confidentiality.</li>
          <li><strong>One-Time Access:</strong> Shared links are configured for one-time access and will automatically expire after first use, as well as after 24 hours from creation, whichever occurs first.</li>
          <li><strong>Responsibility of Users:</strong> Users are expected to treat generated links with caution and share only through secure channels.</li>
      </ul>

      <h2>5. Data Integrity and Compliance</h2>
      <p>All users must comply with CapIntel's Information Security Policies, including but not limited to:</p>
      <ul>
          <li>Not sharing any data that is not directly relevant to their work responsibilities.</li>
          <li>Reporting any suspicious activity or unauthorized access immediately to the IT Ops team.</li>
      </ul>

      <h2>6. Disclaimer of Liability</h2>
      <p>CapIntel strives to maintain the highest levels of security for the Portal; however, it does not guarantee the absolute security of information shared. Users are responsible for the appropriate use of the Portal and assume responsibility for any breach resulting from unauthorized sharing.</p>

      <h2>7. Amendments</h2>
      <p>CapIntel reserves the right to modify or discontinue the Portal at any time without notice and may update these Terms of Use periodically. Continued use of the Portal following any changes to these terms indicates acceptance of the revised Terms of Use.</p>

      <h2>8. Acknowledgment</h2>
      <p>By using the Portal, you acknowledge that you have read and understood these Terms of Use, and you agree to comply with them fully.</p>
    </div>
  );
};
